import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { EnvironmentService } from '@offconon/shared/utils/services/environment';

@Injectable({
  providedIn: 'root',
})
export class TranslateDebugService {
  private platformId = inject(PLATFORM_ID);
  private environmentService = inject(EnvironmentService);

  public isDebug$ = new BehaviorSubject<boolean>(false);

  private readonly handleKeyDown = (e: KeyboardEvent) => {
    if (this.environmentService?.environment?.production) return;
    if (e.repeat) return;
    if (!this.canHandle(e)) return;
    const key = e.key.toLowerCase();
    const isAltN = e.altKey && key === 'n';
    const isCmdK = (e.metaKey || e.ctrlKey) && key === 'k';

    if (isAltN || isCmdK) {
      this.toggleDebugLanguage();
      e.preventDefault();
      e.stopPropagation();
    }
  };

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('keydown', this.handleKeyDown, { capture: true });
    }
  }

  private canHandle(e: KeyboardEvent): boolean {
    const target = e.target as HTMLElement | null;
    if (!target) return true;
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') return false;
    if ((target as any).isContentEditable) return false;
    return true;
  }

  private toggleDebugLanguage(): void {
    if (this.environmentService?.environment?.production) return;
    this.isDebug$.next(!this.isDebug$.value);
  }
}
